(() => {
  const onReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  const money = (cents) => {
    const n = (Number(cents) || 0) / 100;
    return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  onReady(() => {
    document.querySelectorAll('[data-sg-nn]').forEach((root) => {
      const variants = JSON.parse(root.querySelector('[data-sg-nn-variants]')?.textContent || '[]');
      const flavourList = JSON.parse(root.querySelector('[data-sg-nn-flavour-list]')?.textContent || '[]')
        .map((f) => String(f).trim())
        .filter(Boolean);
      const form = root.querySelector('[data-sg-nn-form]');
      const variantInput = root.querySelector('[data-sg-nn-variant]');
      const propsWrap = root.querySelector('[data-sg-nn-props]');
      const flavoursWrap = root.querySelector('[data-sg-nn-flavours]');
      const pickedEl = root.querySelector('[data-sg-nn-picked]');
      const warnEl = root.querySelector('[data-sg-nn-warn]');
      const nowEl = root.querySelector('[data-sg-nn-now]');
      const wasEl = root.querySelector('[data-sg-nn-was]');
      const saveEl = root.querySelector('[data-sg-nn-save]');
      const buyBtn = root.querySelector('.sr-headless-checkout');
      const wa = root.querySelector('[data-sg-nn-wa]');

      let selected = [];
      let packs = 2;

      const currentVariant = () => {
        const id = Number(variantInput?.value);
        return variants.find((v) => v.id === id) || variants[0];
      };

      const syncPrice = () => {
        const v = currentVariant();
        if (!v) return;
        const packsCount = Number(v.packs) || packs;
        const full = Number(v.compare) || packsCount * 30000;
        const prepaid = Math.round(v.price * 0.9);
        const saveTotal = full - prepaid;
        if (nowEl) nowEl.textContent = money(v.price);
        if (wasEl) {
          wasEl.textContent = money(full);
          wasEl.hidden = full <= v.price;
        }
        if (saveEl) {
          saveEl.textContent = saveTotal > 0 ? `Save up to ${money(saveTotal)}` : '';
        }
        const sticky = document.querySelector('[data-sg-sticky-atc] span');
        if (sticky) sticky.textContent = money(v.price);
      };

      const readSelected = () => {
        selected = Array.from(flavoursWrap?.querySelectorAll('[data-sg-nn-pick]') || []).map(
          (el) => el.value || ''
        );
      };

      const flavourProperties = () => {
        const properties = {};
        selected.forEach((flavour, i) => {
          if (!flavour) return;
          properties[`Pack ${i + 1} flavour`] = flavour;
        });
        const filled = selected.filter(Boolean);
        if (filled.length) properties.Flavours = filled.join(', ');
        return properties;
      };

      const syncProps = () => {
        if (!propsWrap) return;
        propsWrap.innerHTML = '';
        const properties = flavourProperties();
        Object.keys(properties).forEach((key) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = properties[key];
          propsWrap.appendChild(input);
        });
      };

      const syncPickedCopy = () => {
        const filled = selected.filter(Boolean);
        if (!pickedEl) return;
        if (filled.length === 0) {
          pickedEl.textContent = 'Choose a flavour for every pack.';
        } else if (filled.length < packs) {
          pickedEl.textContent = `${filled.length} of ${packs} packs chosen — ${filled.join(' · ')}`;
        } else {
          pickedEl.textContent = `Selected: ${filled.join(' · ')}`;
        }
      };

      const renderPicks = () => {
        if (!flavoursWrap) return;
        const prev = Array.from(flavoursWrap.querySelectorAll('[data-sg-nn-pick]')).map((el) => el.value);
        flavoursWrap.innerHTML = '';

        for (let i = 0; i < packs; i += 1) {
          const row = document.createElement('label');
          row.className = 'sg-nn__pick';
          row.innerHTML = `
            <span class="sg-nn__pick-label">Pack ${i + 1}</span>
            <span class="sg-nn__pick-field">
              <select data-sg-nn-pick aria-label="Flavour for pack ${i + 1}">
                <option value="">Choose flavour</option>
                ${flavourList
                  .map((flavour) => `<option value="${flavour.replace(/"/g, '&quot;')}">${flavour}</option>`)
                  .join('')}
              </select>
            </span>
          `;
          const select = row.querySelector('select');
          if (prev[i]) select.value = prev[i];
          select.addEventListener('change', () => {
            readSelected();
            if (warnEl) warnEl.hidden = true;
            syncProps();
            syncPickedCopy();
            row.classList.toggle('is-filled', Boolean(select.value));
          });
          row.classList.toggle('is-filled', Boolean(select.value));
          flavoursWrap.appendChild(row);
        }

        readSelected();
        syncProps();
        syncPickedCopy();
        if (warnEl) warnEl.hidden = true;
        syncPrice();
      };

      const setCombo = (input) => {
        if (!input) return;
        packs = Number(input.getAttribute('data-packs') || 2);
        if (variantInput) variantInput.value = input.value;
        root.querySelectorAll('.sg-nn__combo').forEach((el) => {
          el.classList.toggle('is-active', el.contains(input));
        });
        renderPicks();
      };

      root.querySelectorAll('input[name="sg-nn-combo"]').forEach((input) => {
        input.addEventListener('change', () => setCombo(input));
      });

      const ready = () => {
        readSelected();
        if (selected.some((f) => !f) || selected.length < packs) {
          if (warnEl) {
            warnEl.hidden = false;
            warnEl.textContent = `Please choose a flavour for all ${packs} packs.`;
          }
          return false;
        }
        syncProps();
        return true;
      };

      form?.addEventListener('submit', (e) => {
        if (!ready()) e.preventDefault();
      });

      // Fastrr/logistics use item title, not line-item properties.
      // Add with properties for Shopify admin, then open checkout with flavours in the title.
      buyBtn?.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!ready()) return;
        syncProps();

        const variantId = Number(variantInput?.value);
        const properties = flavourProperties();
        if (!variantId || !Object.keys(properties).length) return;

        const withFlavourTitle = (item) => {
          const props = item.properties || {};
          const flavours =
            props.Flavours ||
            Object.keys(props)
              .filter((k) => /flavour/i.test(k))
              .map((k) => props[k])
              .filter(Boolean)
              .join(', ');
          const baseTitle =
            item.variant_title && item.variant_title !== 'Default Title'
              ? `${item.product_title} - ${item.variant_title}`
              : item.product_title || item.title;
          const title = flavours ? `${baseTitle} | Flavours: ${flavours}` : baseTitle;
          const variantTitle = flavours
            ? `${item.variant_title || 'Combo'} | Flavours: ${flavours}`
            : item.variant_title || '';
          return {
            productId: item.product_id,
            title,
            variantId: item.variant_id,
            variantTitle,
            price: parseFloat((Number(item.price) / 100).toFixed(2)),
            quantity: item.quantity,
            image: item.image,
            customAttributes: props,
            item_meta_data: { properties: props },
          };
        };

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties }],
            }),
          });

          const cart = await fetch('/cart.js').then((r) => r.json());
          const products = (cart.items || []).map(withFlavourTitle);

          if (window.shiprocketCheckoutEvents?.buyDirect) {
            window.shiprocketCheckoutEvents.buyDirect({ type: 'cart', products });
            return;
          }
          if (window.HeadlessCheckout?.InitiateDirectCheckout) {
            window.HeadlessCheckout.InitiateDirectCheckout(null, null, products);
            return;
          }
          if (window.shiprocketCheckoutEvents?.buyCart) {
            window.shiprocketCheckoutEvents.buyCart(e);
            return;
          }
        } catch (_) {
          /* fall through to buyProduct */
        }
        if (window.shiprocketCheckoutEvents?.buyProduct) {
          window.shiprocketCheckoutEvents.buyProduct(e);
        }
      }, true);

      wa?.addEventListener('click', () => {
        readSelected();
        const v = currentVariant();
        const lines = [
          `Hi Raza Rida Care, I want to order Nutri Nuts.`,
          `Combo: ${v?.title || ''}`,
          `Flavours: ${selected.filter(Boolean).join(', ') || 'not selected'}`,
        ];
        wa.href = `https://wa.me/918006926399?text=${encodeURIComponent(lines.join('\n'))}`;
      });

      const first = root.querySelector('input[name="sg-nn-combo"]:checked')
        || root.querySelector('input[name="sg-nn-combo"]');
      setCombo(first);
      const params = new URLSearchParams(window.location.search);
      const comboParam = Number(params.get('combo') || 0);
      if (comboParam === 2 || comboParam === 3 || comboParam === 4) {
        const match = root.querySelector(`input[name="sg-nn-combo"][data-packs="${comboParam}"]`);
        if (match) {
          match.checked = true;
          setCombo(match);
        }
      }
      syncPrice();
    });
  });
})();
